<template>
  <v-dialog v-model="isOpen" persistent scrollable max-width="500">
    <v-card class="modal-card">
      <v-card-title class="py-0">
        <h2 class="modal-title">
          {{ $t("message.common.chooseProfile") }}
        </h2>
      </v-card-title>

      <v-card-text class="px-0 py-0">
        <div class="modal-content">
          <div class="profile" v-for="profile in profiles" :key="profile.id">
            <span>{{ profile.profile_name }}</span>
            <ui-button
              outlined
              transparent
              color="primary"
              @click="$emit('chooseProfile', profile)"
              :loading="loadingButton"
            >
              {{ $t("message.common.choose") }}
            </ui-button>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <ui-button
          color="primary"
          outlined
          @click="$emit('close', false)"
          class="modal-button"
          :disabled="loadingButton"
        >
          {{ $t("message.common.cancel") }}
        </ui-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ListingsConfigurationPickProfileDialog",
  props: {
    profiles: {
      type: Array,
      default: () => []
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    loadingButton: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: $spacing * 3;
}

.modal-title {
  @include font-size(16px);
  font-family: $font-family-base;
  font-weight: $font-weight-bold;
  margin-bottom: $spacing * 5;
  margin-top: $spacing * 3;
}

.modal-content {
  width: 100%;

  .profile {
    border: 1px solid $gray-200;
    display: flex;
    align-items: center;
    padding: $spacing * 3;
    margin-bottom: $spacing;
    justify-content: space-between;

    &:last-of-type {
      margin-bottom: 1px;
    }
  }
}

.modal-button {
  margin-top: $spacing * 3;
}
</style>
